import { createStyles, Theme } from '@zn-material-ui'
import iconBackImg from '@images/login/icon_back.png'

export default (theme: Theme) =>
  createStyles({
    back: {
      width: '120px',
      height: '120px',
      backgroundColor: '#F9FAFC',
      backgroundImage: `url(${iconBackImg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      cursor: 'pointer',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    innerWrapper: {
      position: 'absolute',
      top: '125px',
      left: '20px',
      width: '100%',
      height: '400px',
      margin: '0 auto',
      overflow: 'hidden',
      '& #loginContent': {
        border: 'none',
        background: '#fff',
        marginRight: '10px',
        borderRadius: '5px',
        width: '100%',
        position: 'absolute',
        fontFamily: 'PingFangSC-Regular !important',
      },
    },
    unionLogin: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '30px',
      opacity: 0.66,
      fontSize: '16px',
      color: '#333333',
      letterSpacing: '0',
      textAlign: 'center',
      cursor: 'pointer',
      '& .title': {
        marginLeft: '7px',
      },
    },
    loginContainer: {
      display: 'block',
      position: 'absolute',
      left: '0',
      width: '500px',
      height: '525px',
      top: '50%',
      marginTop: '-220px',
    },
    title: {
      position: 'absolute',
      left: '120px',
    },
    loginForm: {
      width: '600px',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      position: 'relative',
    },
    hello: {
      color: '#F4F5F8',
      fontSize: 40,
      letterSpacing: 0,
    },
    welcome: {
      marginTop: 10,
      fontSize: 40,
      color: '#363C46',
      letterSpacing: 0,
      fontWeight: 600,
    },
    titleLine: {
      width: 40,
      height: 5,
      marginTop: 18,
      backgroundColor: theme.palette.primary.main,
    },
    loginTitle: {
      marginTop: 60,
    },
    userLogin: {
      fontSize: 18,
      color: theme.palette.primary.main,
      letterSpacing: 0,
    },
    loginLine: {
      marginTop: 19,
      width: 220,
      height: 2,
      backgroundColor: theme.palette.primary.main,
    },
    formContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.secondary.main,
    },
    textField: {
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    loginButtonWrapper: {
      marginTop: 50,
    },
  })
